module.exports = __webpack_public_path__ + "static/media/preferences.82a52d1e.svg";